export enum ProductCategory {
  ESSENCE_SERUM = 'essence-serum',
  MULTI_BALM_STICK = 'multi-balm-stick',
  TONER = 'toner',
  FACIAL_CREAM = 'facial-cream',
  OIL = 'oil',
  CLEANSING_FOAM = 'cleansing-foam',
  LIP_EYE_REMOVER = 'lip-eye-remover',
  SHEET_MASK = 'sheet-mask',
  TONER_PADS = 'toner-pads',
  WASH_OFF_MASK = 'wash-off-mask',
  SLEEPING_MASK = 'sleeping-mask',
  SPOT_PATCH = 'spot-patch',
  SUN_SCREEN = 'sun-screen',
  SUN_CUSHION_COMPACT = 'sun-cushion-compact',
}

export const PRODUCT_CATEGORY_LABELS: Record<ProductCategory, string> = {
  [ProductCategory.ESSENCE_SERUM]: 'Essence & Serum',
  [ProductCategory.MULTI_BALM_STICK]: 'Multi-Balm & Stick',
  [ProductCategory.TONER]: 'Toner',
  [ProductCategory.FACIAL_CREAM]: 'Facial Cream',
  [ProductCategory.OIL]: 'Oil',
  [ProductCategory.CLEANSING_FOAM]: 'Cleansing Foam',
  [ProductCategory.LIP_EYE_REMOVER]: 'Lip & Eye Remover',
  [ProductCategory.SHEET_MASK]: 'Sheet Mask',
  [ProductCategory.TONER_PADS]: 'Toner Pads',
  [ProductCategory.WASH_OFF_MASK]: 'Wash-Off Mask',
  [ProductCategory.SLEEPING_MASK]: 'Sleeping Mask',
  [ProductCategory.SPOT_PATCH]: 'Spot Patch',
  [ProductCategory.SUN_SCREEN]: 'Sun Screen',
  [ProductCategory.SUN_CUSHION_COMPACT]: 'Sun Cushion & Sun Compact',
};

export type CategoryItem = {
  name: string;
  url: string;
  imageUrl?: string;
  imageAlt?: string;
};

export const moisturizerItems: CategoryItem[] = [
  {
    name: 'Essence & Serum',
    url: '/collections/moisturizer/essence-serum-ampoule/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Serum-600x600.webp',
    imageAlt: 'Essence & Serum',
  },
  {
    name: 'Multi-Balm & Stick',
    url: '/collections/moisturizer/multi-balm-stick/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2023/12/cov_47431976419648-1-600x600.jpg',
    imageAlt: 'Multi-Balm & Stick',
  },
  {
    name: 'Toner',
    url: '/collections/moisturizer/toner/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/08/toner.webp',
    imageAlt: 'Toner',
  },

  {
    name: 'Facial Cream',
    url: '/collections/moisturizer/facial-cream/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Facial-Cream-600x600.webp',
    imageAlt: 'Facial Cream',
  },
  {
    name: 'Lotion',
    url: '/collections/moisturizer/lotion/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/08/lotion.webp',
    imageAlt: 'Lotion',
  },
  {
    name: 'Mist',
    url: '/collections/moisturizer/mist/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/mist.webp',
    imageAlt: 'Mist',
  },
  {
    name: 'Oil',
    url: '/collections/moisturizer/oil/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/oil-600x600.webp',
    imageAlt: 'Oil',
  },
  {
    name: 'Gel',
    url: '/collections/moisturizer/gel/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100002876_1-1.webp',
    imageAlt: 'Gel',
  },
  {
    name: 'Cream',
    url: '/collections/moisturizer/cream/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Facial-Cream-600x600.webp',
    imageAlt: 'Cream',
  },
];

export const cleanserItems: CategoryItem[] = [
  {
    name: 'Cleansing Foam',
    url: '/collections/cleanser/cleansing-foam/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/08/cleansing-foam.webp',
    imageAlt: 'Cleansing Foam',
  },
  {
    name: 'Cleansing Oil',
    url: '/collections/cleanser/cleansing-oil/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Cleansing-Oil-600x600.webp',
    imageAlt: 'Cleansing Oil',
  },
  {
    name: 'Cleansing Gel & Powder',
    url: '/collections/cleanser/cleansing-gel-powder/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/08/cleansing-gel-powder.webp',
    imageAlt: 'Cleansing Gel & Powder',
  },
  {
    name: 'Cleansing Soap',
    url: '/collections/cleanser/cleansing-soap/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Cleansing-Soap-600x600.webp',
    imageAlt: 'Cleansing Soap',
  },
  {
    name: 'Lip & Eye Remover',
    url: '/collections/cleanser/lip-eye-remover/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Lip-Eye-Remover-600x600.webp',
    imageAlt: 'Lip & Eye Remover',
  },
  {
    name: 'Cleansing Wipes & Sheets',
    url: '/collections/cleanser/cleansing-wipes-sheets/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Cleansing-Wipes-Sheets-600x600.webp',
    imageAlt: 'Cleansing Wipes & Sheets',
  },
  {
    name: 'Cleansing Water',
    url: '/collections/cleanser/cleansing-water/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Cleansing-Water-600x600.webp',
    imageAlt: 'Cleansing Water',
  },
  {
    name: 'Cleansing Lotion & Cream',
    url: '/collections/cleanser/cleansing-lotion-cream/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Cleansing-Lotion-Cream-600x600.webp',
    imageAlt: 'Cleansing Lotion & Cream',
  },
  {
    name: 'Scrub & Peeling',
    url: '/collections/cleanser/scrub-peeling/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Scrub-Peeling-600x600.webp',
    imageAlt: 'Scrub & Peeling',
  },
];

export const maskItems: CategoryItem[] = [
  {
    name: 'Sheet Mask',
    url: '/collections/mask-pack/sheet-mask/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/08/sheet-mark.webp',
    imageAlt: 'Sheet Mask',
  },
  {
    name: 'Toner Pads',
    url: '/collections/mask-pack/toner-pads/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/toner-pads-600x600.webp',
    imageAlt: 'Toner Pads',
  },
  {
    name: 'Wash-Off Mask',
    url: '/collections/mask-pack/wash-off-mask/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Wash-Off-Mask-600x600.webp',
    imageAlt: 'Wash-Off Mask',
  },
  {
    name: 'Sleeping Mask',
    url: '/collections/mask-pack/sleeping-mask/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/sleeping-mask.webp',
    imageAlt: 'Sleeping Mask',
  },
  {
    name: 'Eye Patch',
    url: '/collections/mask-pack/eye-patch/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Eye-Patch-600x600.jpg',
    imageAlt: 'Eye Patch',
  },
  {
    name: 'Rubber & Modeling Mask',
    url: '/collections/mask-pack/rubber-modeling-mask/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Rubber-Modeling-Mask-600x600.webp',
    imageAlt: 'Rubber & Modeling Mask',
  },
  {
    name: 'Nose Patch',
    url: '/collections/mask-pack/nose-patch/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Nose-Patch-600x600.webp',
    imageAlt: 'Nose Patch',
  },
  {
    name: 'Peel-Off Mask',
    url: '/collections/mask-pack/peel-off-mask/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Peel-Off-Mask-600x600.webp',
    imageAlt: 'Peel-Off Mask',
  },
  {
    name: 'Spot Patch',
    url: '/collections/mask-pack/spot-patch/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Spot-Patch-600x600.webp',
    imageAlt: 'Spot Patch',
  },
];

export const sunCareItems: CategoryItem[] = [
  {
    name: 'Sun Screen',
    url: '/collections/sun-care/sun-screen/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100000927_1-1-600x600.webp',
    imageAlt: 'Sun Screen',
  },
  {
    name: 'Sun Cushion & Sun Compact',
    url: '/collections/sun-care/sun-cushion-sun-compact/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Sun-Cushion-Sun-Compact-600x600.webp',
    imageAlt: 'Sun Cushion & Sun Compact',
  },
  {
    name: 'Sun Stick',
    url: '/collections/sun-care/sun-stick/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/07/Sun-Stick-600x600.webp',
    imageAlt: 'Sun Stick',
  },
];

export const maskPackItems: CategoryItem[] = [
  {
    name: 'Wash-Off Mask',
    url: '/collections/mask-pack-2/wash-off-mask-mask-pack-2/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/woocommerce-placeholder-600x600.png',
    imageAlt: 'Wash-Off Mask',
  },
];

// Explore Products Categories for ExploreProductsSection
export interface ExploreProductCategory {
  id: number;
  category: string;
  subCategories: Array<{
    name: string;
    link: string;
  }>;
}

const createCollectionLink = (collection: string, path: string): string => {
  return `/collections/${collection}/${path}/`;
};

const moisturizerSubCategories = [
  { name: 'Toner', path: 'toner' },
  { name: 'Lotion', path: 'lotion' },
  { name: 'Essence & Serum', path: 'essence-serum-ampoule' },
  { name: 'Mist', path: 'mist' },
  { name: 'Oil', path: 'oil' },
  { name: 'Gel', path: 'gel' },
  { name: 'Cream', path: 'cream' },
  { name: 'Facial Cream', path: 'cream/facial-cream' },
  { name: 'Eye & Neck Cream', path: 'cream/eye-neck-cream' },
  { name: 'Multi-Balm & Stick', path: 'cream/multi-balm-stick' },
];

const cleanserSubCategories = [
  { name: 'Cleansing Foam', path: 'cleansing-foam' },
  { name: 'Cleansing Gel & Powder', path: 'cleansing-gel-powder' },
  { name: 'Cleansing Soap', path: 'cleansing-soap' },
  { name: 'Cleansing Oil', path: 'cleansing-oil' },
  { name: 'Cleansing Water', path: 'cleansing-water' },
  { name: 'Lip & Eye Remover', path: 'lip-eye-remover' },
  { name: 'Cleansing Wipes & Sheets', path: 'cleansing-wipes-sheets' },
  { name: 'Cleansing Lotion & Cream', path: 'cleansing-lotion-cream' },
  { name: 'Scrub & Peeling', path: 'scrub-peeling' },
  { name: '  Gel & Gommage', path: 'scrub-peeling/gel-gommage-cream-scrub-peeling' },
  { name: '  Peeling Toner & Cotton Swab', path: 'scrub-peeling/peeling-toner-cotton-swab' },
  { name: '  Peeling Pad', path: 'scrub-peeling/peeling-pad' },
  { name: '  Powder & Scrub', path: 'scrub-peeling/powder-scrub' },
];

const maskSubCategories = [
  { name: 'Sheet Mask', path: 'sheet-mask' },
  { name: 'Wash-Off Mask', path: 'wash-off-mask' },
  { name: 'Peel-Off Mask', path: 'peel-off-mask' },
  { name: 'Sleeping Mask', path: 'sleeping-mask' },
  { name: 'Rubber & Modeling Mask', path: 'rubber-modeling-mask' },
  { name: 'Toner Pads', path: 'toner-pads' },
  { name: 'Nose Patch', path: 'nose-patch' },
  { name: 'Spot Patch', path: 'spot-patch' },
  { name: 'Eye Patch', path: 'eye-patch' },
];

const sunCareSubCategories = [
  { name: 'Sun Screen', path: 'sun-screen' },
  { name: 'Sun Stick', path: 'sun-stick' },
  { name: 'Sun Cushion & Sun Compact', path: 'sun-cushion-sun-compact' },
];

const specialCategories = [
  { name: 'Best Sellers', link: '/shop/?orderby=score' },
  { name: 'Trend', link: '/trend/' },
];

const mapSubCategories = (subCategories: Array<{ name: string; path: string }>, collection: string) => {
  return subCategories.map(({ name, path }) => ({
    name,
    link: createCollectionLink(collection, path),
  }));
};

export const exploreProductCategories: ExploreProductCategory[] = [
  {
    id: 1,
    category: 'Moisturizer',
    subCategories: mapSubCategories(moisturizerSubCategories, 'moisturizer'),
  },
  {
    id: 2,
    category: 'Cleanser',
    subCategories: mapSubCategories(cleanserSubCategories, 'cleanser'),
  },
  {
    id: 3,
    category: 'Mask',
    subCategories: mapSubCategories(maskSubCategories, 'mask-pack'),
  },
  {
    id: 4,
    category: 'Sun Care',
    subCategories: mapSubCategories(sunCareSubCategories, 'sun-care'),
  },
  {
    id: 5,
    category: 'Shop All',
    subCategories: specialCategories,
  },
];

// Why SkinSeoul Sale Points for WhySkinSeoulSection (Home)
export interface SalePoint {
  title: string;
  subtitle: string;
  icon?: string;
}

export const salePoints: SalePoint[] = [
  {
    title: '#1',
    subtitle: 'Destination for\nKorean Skincare',
  },
  {
    title: '100%',
    subtitle: 'Authenticity Guarantee',
  },
  {
    title: '',
    subtitle: 'Recommendations by\nSkinSight AI™',
    icon: 'Sparkles',
  },
  {
    title: '',
    subtitle: 'Lowest Pricing',
    icon: 'PercentCircle',
  },
];
